module.exports = __webpack_public_path__ + "resource-check.png";